import { UnitStatusEnum, getUnitStatusString } from '@/enums/UnitStatus';
import { Ref, isRef } from 'vue';

const timezone = 'America/New_York';

export function convertISOZuluDateToLocalDate(dateString: string): Date {
  const [year, month, day] = dateString.split('T')[0].split('-').map(Number);
  const convertedDate = new Date(year, month - 1, day);
  return convertedDate;
}

export function getFormattedPublishDateTime(dateString: string, locale: string | Ref<string>) {
  const date = new Date(dateString);
  const resolvedLocale = isRef(locale) ? locale.value : locale;
  const optionsDate: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric', timeZone: timezone };
  const dateFormattedString = date.toLocaleDateString(resolvedLocale, optionsDate);

  return dateFormattedString;
}

export function getFormattedPublishDate(dateString: string, locale: string | Ref<string>) {
  const date = new Date(dateString);
  const resolvedLocale = isRef(locale) ? locale.value : locale;
  const optionsDate: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric', timeZone: timezone };
  const dateFormattedString = date.toLocaleDateString(resolvedLocale, optionsDate);

  return dateFormattedString;
}

export function formatDateAsISO(date: Date | string | null | undefined): string {
  if (!date) {
    return '';
  }
  
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  
  if (isNaN(dateObj.getTime())) {
    return '';
  }
  
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');
  
  return `${year}-${month}-${day}`;
}

export function formatAvailabilityDate(
  date: Date | undefined,
  locale: string | Ref<string>,
  t: (key: string) => string,
  mode: 'purchase' | 'rental' | undefined,
  status?: UnitStatusEnum
): string {
  // Une unité louée garde la date d'emménagement de son bail : l'afficher laisserait croire qu'elle se libère à cette date
  if (getUnitStatusString(status) === UnitStatusEnum.Rented) {
    return t('common.notAvailableAbbreviated');
  }

  // Pour le mode purchase avec statut Available, toujours afficher quelque chose même si pas de date
  if (!date && mode === 'purchase' && status === UnitStatusEnum.Available) {
    return t('common.rightNow');
  }

  if (!date) {
    return t('common.notAvailableAbbreviated');
  }
  
  const dateValue = new Date(date);
  const today = new Date();
  
  // Réinitialiser l'heure pour comparer uniquement les dates
  today.setHours(0, 0, 0, 0);
  dateValue.setHours(0, 0, 0, 0);
  
  // Si la date est aujourd'hui ou dans le passé, afficher "Dès maintenant"
  if (dateValue <= today) {
    return t('common.rightNow');
  }
  const resolvedLocale = isRef(locale) ? locale.value : locale;

  return dateValue.toLocaleDateString(resolvedLocale, {
    year: 'numeric',
    month: 'long'
  });
}
